import PropTypes from 'prop-types';
import React, { Fragment , useState, useEffect } from 'react';
import { ListGroup, ListGroupItem, Col, Row, Button , Modal, ModalBody, Container, ModalFooter } from 'reactstrap';
import { Link } from 'react-router-dom';
import { isOpera } from 'react-device-detect';
import { FaShoppingBag } from 'react-icons/fa';
import { FiShoppingBag } from 'react-icons/fi';

const propTypes = {
  getCart: PropTypes.array.isRequired,
  empty: PropTypes.bool.isRequired
};

const CheckoutMiniSummaryPreview = ({
  getCart, 
  empty
}) => {

  const styles = {
    fontSize: {
      fontSize: '13px'
    },
  };
  const [isOpen, toggle] = useState(true);
  const CardPreview =       
  <Modal backdrop={true} toggle={()=>toggle(!isOpen)} fade={false} className="wow animated slideInRight" id="cartModal" isOpen={isOpen}  style={{position:'fixed', right:'0px', margin:'0', top:"0px", height:'100%', width:'40%'}} >
    <ModalBody style={{height:'100%', overflow:'scroll'}}>
    {
      !empty ?
    <Container>      
      {
        getCart.map(x=> 
          <Row key={x._id} className="mx-2 my-4 shadow rounded">
            {/* <Col xs='9'><p style={styles.fontSize}>{x.quantity}X {x.title}</p><p> {x.price}</p><p> size: {x.selectedSize} color: {x.selectedColor}</p></Col>
            <Col xs='3'><img style={{width: '60px'}} src={x.images[0]} alt="" /></Col> */}

        <Col xs="6"><img src={x.images[0]} style={{width: '100%'}} alt="" /> </Col>
        <Col xs="6">
          <b>{x.title}</b>
          <div>Rs.{x.price}</div>
          <div>color: {x.selectedColor}</div>
          <div>size: {x.selectedSize}</div>
        </Col>
          </Row>
  
        )
      }  
       
    </Container>
    :
    <div className="d-flex justify-content-center flex-column align-items-center" style={{height:'100%'}}>
     <div><FiShoppingBag size={45}/></div>
      <h3> Cart is Empty </h3>
    </div>
    }
  </ModalBody>
  <ModalFooter>
      <Link to="/cart" className="text-white" onClick={toggle}> <Button outline style={{background:'#000', color:'#fff', borderRadius:'20px'}}  >Edit cart</Button></Link>{' '}
      <Link to="/checkout" className="text-white" onClick={toggle}> <Button style={{background:'#000', color:'#fff', borderRadius:'20px'}} >Checkout</Button></Link>
    </ModalFooter>
   </Modal> ;


  return CardPreview;

}

CheckoutMiniSummaryPreview.propTypes = propTypes;

export default CheckoutMiniSummaryPreview;




// WEBPACK FOOTER //
// ./src/components/Checkout-mini-summary-preview.js